module.exports = __webpack_public_path__ + "static/img/presysv21Three.162320a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv21Three.png
// module id = NqZJ
// module chunks = 1